import { render, staticRenderFns } from "./transferDialog.vue?vue&type=template&id=7b080fa3&scoped=true"
import script from "./transferDialog.vue?vue&type=script&lang=js"
export * from "./transferDialog.vue?vue&type=script&lang=js"
import style0 from "./transferDialog.vue?vue&type=style&index=0&id=7b080fa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b080fa3",
  null
  
)

export default component.exports